export default __webpack_public_path__ + "static/media/ed_2.d13b7d53.mp3";